import React, { Component } from "react";
import { Checkbox, Form, Input, Radio, Select } from "antd";
import { connect } from "react-redux";
import style from "./list.module.sass";
import { Http } from "../../../../helpers/axois";
import { pushToast } from "../../../../stateManager/store/toast/actions";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

interface State {
  displayNameErr?: string;
  functionName?: string;
  functionNameErr?: string;
  executionTypeErr?: string;
  saveFnModalVisibility:boolean;
  languageErr:string;
  allowedMethodsErr: string;
}

interface Props {
  onSubmit: (submit: () => void) => void;
  appId?: any;
  versionId?: any;
  getFunction: () => void;
  editInitialData?: any;
  editable?: boolean;
  pushToast?: (data: any) => void;
  setvisible?: (visible: boolean) => void;
  currentBranch?: any;
  displayName?:string;
  setDisplayName?: (displayName: string) => void;
  functionName?:string;
  setFunctionName?:(functionName:string)=>void;
  language?:string;
  setLanguage?:(language:string)=>void;
  mode?: string;
  setMode?: (mode: string) => void;
  cacheable?: boolean;
  setCacheable?: (cacheable: boolean) => void;
  exposeEndpoint?: boolean;
  setExposeEndpoint?: (exposeEndpoint:boolean) => void;
  allowedMethods?: string[];
  setAllowedMethods?: (allowedMethods:string[]) => void;
  apiKeyAuth?: boolean;
  setApiKeyAuth?: (apiKeyAuth:boolean) => void;
}

class AppFunction extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      displayNameErr: "",
      functionNameErr: "",
      saveFnModalVisibility: false,
      languageErr:'',
      allowedMethodsErr: ''
    };
    this.props.onSubmit(this.onSubmit);
  }
  onSubmit = () => {
    if (this.props.functionName && this.props.displayName && this.props.language && (!this.props.exposeEndpoint  || (this.props.exposeEndpoint && this.props.allowedMethods?.length))) {
      let { editable, editInitialData } = this.props;
      if (!editable) {
        this.saveService();
      } else if (editInitialData) {
        this.updateService(editInitialData.id);
      }
    } else{
      if (!this.props.displayName){
        this.setState({ displayNameErr: "required"});
      }
      if(!this.props.functionName){
        this.setState({ functionNameErr: "required"});
      }
      if(!this.props.mode){
        this.setState({ executionTypeErr: "required"});
      }
      if (!this.props.language){
        this.setState({ languageErr: "required"});
      }
      if (!this.props.allowedMethods || !this.props.allowedMethods.length) {
        this.setState({ allowedMethodsErr: "required"});
      }
    }
  };
  saveService() {
    const { setvisible, appId, versionId, setFunctionName, setDisplayName, setMode, setLanguage, setCacheable, cacheable, setExposeEndpoint, exposeEndpoint, allowedMethods, setAllowedMethods, apiKeyAuth, setApiKeyAuth } = this.props;
    if (!this.props.functionName) {
      this.props.pushToast && this.props.pushToast({ type: "error", message: "Function name not found" });
      return;
    }
    if (!this.props.mode) {
      this.setState({ executionTypeErr: "required" });
      return;
    }
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
    const data: any = {
      name: this.props.functionName,
      displayName: this.props.displayName,
      appId: appId,
      versionId: versionId,
      lang: this.props.language,
      mode: this.props.mode,
      branchId: currentBranchId,
    };
    if(this.props.mode === 'server') {
      data.cacheable = cacheable
      data.exposeEndpoint = exposeEndpoint;
    }
    if (data.exposeEndpoint) {
      data.allowedMethods = allowedMethods || [];
      data.apiKeyAuth = apiKeyAuth;
    }
    Http.post("functions", data).subscribe(
      (res) => {
        this.props.pushToast && this.props.pushToast({ type: "success", message: "Function saved successfully" });
        this.props.getFunction();
        setvisible && setvisible(false);
      },
      (err) => {
        if (err && err.code === "23505") {
          this.props.pushToast && this.props.pushToast({ type: "error", message: "FUnction name already Exists" });
        } else {
          this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : " function save failed" });
        }
        setvisible && setvisible(false);
      }
    );
    setFunctionName && setFunctionName("");
    setDisplayName && setDisplayName("");
    setMode && setMode("");
    setLanguage && setLanguage("");
    setCacheable && setCacheable(false);
    setExposeEndpoint && setExposeEndpoint(false); 
    setAllowedMethods && setAllowedMethods([])
    setApiKeyAuth && setApiKeyAuth(true)
  }

  updateService(serviceId?: string) {
    const { apiKeyAuth, setApiKeyAuth, setvisible, appId, versionId, setFunctionName, setDisplayName, setMode, setLanguage, cacheable, setCacheable, setExposeEndpoint, exposeEndpoint, allowedMethods, setAllowedMethods } = this.props;
    const data: any = {
      name: this.props.functionName,
      displayName: this.props.displayName,
      mode: this.props.mode,
      appId: appId,
      versionId: versionId,
    };
    if(this.props.mode === 'server') {
      data.cacheable = cacheable;
      data.exposeEndpoint = exposeEndpoint;
    }
    if (data.exposeEndpoint) {
      data.allowedMethods = allowedMethods;
      data.apiKeyAuth = apiKeyAuth;
    }
    Http.put(`/functions/${serviceId}`, data).subscribe(
      (res) => {
        this.props.pushToast && this.props.pushToast({ type: "success", message: "Function updated successfully" });
        this.props.getFunction();
        setvisible && setvisible(false);
      },
      (err) => {
        if (err && err.code === "23505") {
          this.props.pushToast && this.props.pushToast({ type: "error", message: "FUnction name already Exists" });
        } else {
          this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Function updation failed" });
        }
        setvisible && setvisible(false);
      }
    );
    setFunctionName && setFunctionName("");
    setDisplayName && setDisplayName("");
    setMode && setMode("");
    setLanguage && setLanguage("");
    setCacheable && setCacheable(false);
    setExposeEndpoint && setExposeEndpoint(false);
    setAllowedMethods && setAllowedMethods([]);
    setApiKeyAuth && setApiKeyAuth(true);
  }

  checkFunctionType = (functionType: any) => {
    if (functionType === 'server' && typeof this.props.setCacheable === "function") {
      this.props.setCacheable(false);
    }
  }

  render() {
    let {apiKeyAuth, setApiKeyAuth, editable, setAllowedMethods, allowedMethods, editInitialData, setDisplayName, displayName, functionName, setFunctionName,language, setLanguage, setMode, setCacheable, cacheable, mode, setExposeEndpoint, exposeEndpoint } = this.props;
    let { functionNameErr, displayNameErr, executionTypeErr,languageErr, allowedMethodsErr } = this.state;
    return (
      <div>
        <Form {...formItemLayout} className={style.app + " override-content"}>
          <Form.Item
            validateStatus={displayNameErr && "error"}
            help={displayNameErr}
            label={<span className={style.labelName}>Display Name</span>}
          >
            <Input
              data-test-id="function_display_name"
              defaultValue={editInitialData && editInitialData.displayName}
              value={displayName && displayName}
              onChange={(e) => {
                const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;                               ;
                if (e.target.value === '' || re.test(e.target.value)) {
                  let val =  e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "") 
                  let value =  val.replace(/ /g,"_") 
                this.setState({ displayNameErr: "" })
                setDisplayName && setDisplayName(e.target.value)
                 !editInitialData && setFunctionName && setFunctionName(value)
                }}

              }
            />
          </Form.Item>
          <Form.Item
            validateStatus={functionNameErr && "error"}
            help={functionNameErr}
            label={<span className={style.labelName}>Name(identifier)</span>}
          >
            <Input
              data-test-id="function_name"
              disabled={editInitialData}
              defaultValue={editInitialData && editInitialData.name}
              value={functionName}
              onChange={(e) =>{
                const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                                if (e.target.value === '' || re.test(e.target.value)) {
                this.setState({ functionNameErr: "" })
                setFunctionName && setFunctionName(e.target.value.replace(/ /g, "_"))}
              }
            }
            />
          </Form.Item>
          <Form.Item validateStatus={executionTypeErr && "error"} help={executionTypeErr} label={<span className={style.labelName}>Execution Type</span>}>
            <Radio.Group defaultValue={editInitialData && editInitialData.mode} 
            onChange={(e) => {
              this.setState({ executionTypeErr:""})
              setMode && setMode(e.target.value)
              if (e.target.value === "client") {
                setExposeEndpoint && setExposeEndpoint(false);
              }
              this.checkFunctionType(e.target.value)}
              }>
              <Radio data-test-id="client" value={"client"}>
                <span>Client</span>
              </Radio>
              <Radio data-test-id="server" value={"server"}>
                <span>Server</span>
              </Radio>
            </Radio.Group>
          </Form.Item>
          {
             mode === 'server' && (
              <div style={{display: "flex", padding: "10px 20px", gap:"10px"}}>
                <div>
                  <Checkbox
                    data-test-id="cacheable"
                    defaultChecked={editInitialData && editInitialData.cacheable}
                    checked={cacheable}
                    onChange={(e: any) => setCacheable && setCacheable(e.target.checked)}
                  > Cache for Offline </Checkbox>
                </div>
                <div>
                  <Checkbox
                    data-test-id="expose_api"
                    defaultChecked={editInitialData && editInitialData.exposeEndpoint}
                    checked={exposeEndpoint}
                    onChange={(e: any) =>{ 
                      setExposeEndpoint && setExposeEndpoint(e.target.checked);
                      if (e.target.checked) {
                        setApiKeyAuth && setApiKeyAuth(e.target.checked)
                      }
                    }}
                  > Expose Endpoint </Checkbox>
                </div>
                {exposeEndpoint ? <div>
                  <Checkbox
                    data-test-id="api_key_auth"
                    defaultChecked={editInitialData && editInitialData.apiKeyAuth}
                    checked={apiKeyAuth}
                    onChange={(e: any) => setApiKeyAuth && setApiKeyAuth(e.target.checked)}
                  > Api Key Auth </Checkbox>
                </div> : <></>}
              </div>
            )
          }
          {
            (mode === 'server' && exposeEndpoint) && (
              <Form.Item validateStatus={allowedMethodsErr && "error"} help={allowedMethodsErr} label={<span className={style.labelName}>Allowed Methods</span>}>
                <Select mode="multiple"  data-test-id="allowed_method" value={allowedMethods || []} onChange={((e: any) => {setAllowedMethods && setAllowedMethods(e); this.setState({ allowedMethodsErr: "" });})}>
                  <Option data-test-id="get" value="get">GET</Option>
                  <Option data-test-id="post" value="post">POST</Option>
                  <Option data-test-id="put" value="put">PUT</Option>
                  <Option data-test-id="delete" value="delete">DELETE</Option>
                </Select>
              </Form.Item>
            )
          }
          <Form.Item validateStatus={languageErr && "error"} help={languageErr} label={<span className={style.labelName}>Language</span>}>
            <Select data-test-id="language" disabled={this.props.editInitialData} value={language} onChange={((e: any) => {setLanguage && setLanguage(e); this.setState({ languageErr: "" });})}>
              <Option data-test-id="javascript" value="javascript">JavaScript</Option>
              <Option data-test-id="typescript" value="typescript">TypeScript</Option>
            </Select>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentBranch: state.apps.appBranch
  }
}

export default connect(mapStateToProps, { pushToast })(AppFunction);
